var _vars = require('./vars')._vars;
var shared = require('./shared');
var difyApi = require('./providers/dify/api');

function generateToken() {
    return difyApi.generateToken().then(function (data) {
        if (data && data.token) {
            _vars.token = 'Bearer ' + data.token;
            return true;
        }
        return false;
    }).catch(function (error) {
        console.log("Token generation failed");
        return false;
    });
}

function handleSuggestedEvents() {
    document.querySelector('.suggested-container').addEventListener('click', function(e) {
        if(e.target.tagName === 'A') {
           var query = e.target.textContent;
           _vars.promptId = e.target.getAttribute('data-prompt-id');
            if (query) {
                // Set querySource and flag BEFORE analytics so getMsgSubmitMethod() returns 'initial'
                // for the msg-submit-clkc context call and the msg-submit fired inside handleSearch
                _vars.querySource = 'Initial prompt';
                _vars.isInitialPromptQuery = true;

                // Set context for the suggested prompt click analytics
                shared.setQueryWordCount(query.trim());
                var attrs = shared.getAnalyticsAttributes();
                
                // Use wrapper to set context ONLY for the wmdPageLink call that already happened in onclick
                // The wmdPageLink was already called inline, so we just need to handle the search
                shared.withAnalyticsContext('msg-submit-clkc', function() {
                    // Context is set for the analytics call that was made
                    // Now just trigger the search (which will have its own msg-submit analytics)
                }, {
                    queryWordCount: attrs.queryWordCount,
                    threadId: attrs.threadId,
                    runId: attrs.runId,
                    leadConceptId: attrs.leadConceptId
                });
                
                // Handle the search after context is set and removed
                shared.handleSearch(query.trim());
            }
        }
    });
    
    // Handle mobile accordion functionality
    handleMobileAccordion();
}

function handleMobileAccordion() {
    // Only apply accordion behavior on mobile breakpoint
    if (window.innerWidth <= 767) {
        var cards = document.querySelectorAll('.suggested-card');
        cards.forEach(function(card, index) {
            // Set all cards to collapsed by default on mobile
            card.classList.add('collapsed');
            card.classList.remove('expanded');
            
            // Create header structure for mobile accordion
            var ul = card.querySelector('ul');
            var headingLi = ul.querySelector('li.heading');
            
            if (headingLi) {
                // Create accordion header
                var header = document.createElement('div');
                header.className = 'suggested-card-header';
                header.innerHTML = headingLi.innerHTML;
                
                // Add expand icon
                var expandIconSvg = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.113573 3.10615C0.262056 2.96177 0.499469 2.96509 0.643851 3.11357L6 8.62183L11.3561 3.11357C11.5005 2.96509 11.7379 2.96177 11.8864 3.10615C12.0349 3.25053 12.0382 3.48794 11.8939 3.63643L6.53402 9.14847C6.24032 9.45051 5.75968 9.45051 5.46598 9.14847L0.106149 3.63643C-0.038233 3.48794 -0.0349092 3.25053 0.113573 3.10615Z" fill="#161B1D"/>
</svg>
`;
var collapseIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.113573 3.10615C0.262056 2.96177 0.499469 2.96509 0.643851 3.11357L6 8.62183L11.3561 3.11357C11.5005 2.96509 11.7379 2.96177 11.8864 3.10615C12.0349 3.25053 12.0382 3.48794 11.8939 3.63643L6.53402 9.14847C6.24032 9.45051 5.75968 9.45051 5.46598 9.14847L0.106149 3.63643C-0.038233 3.48794 -0.0349092 3.25053 0.113573 3.10615Z" fill="#161B1D"/>
</svg>
`;
                var expandIcon = document.createElement('div');
                expandIcon.className = 'expand-icon';
                expandIcon.innerHTML= expandIconSvg;
                header.appendChild(expandIcon);
                
                // Create content wrapper
                var content = document.createElement('div');
                content.className = 'suggested-card-content';
                content.appendChild(ul);
                
                // Clear card and add new structure
                card.innerHTML = '';
                card.appendChild(header);
                card.appendChild(content);
                
                // Add click handler for accordion
                header.addEventListener('click', function() {
                    toggleAccordion(card);
                });
            }
        });
    }
}

function toggleAccordion(card) {
    var isExpanded = card.classList.contains('expanded');
    
    // Close all other cards (accordion behavior - only one open at a time)
    var allCards = document.querySelectorAll('.suggested-card');
    allCards.forEach(function(otherCard) {
        if (otherCard !== card) {
            otherCard.classList.remove('expanded');
            otherCard.classList.add('collapsed');
        }
    });
    
    // Toggle current card
    if (isExpanded) {
        card.classList.remove('expanded');
        card.classList.add('collapsed');
    } else {
        card.classList.remove('collapsed');
        card.classList.add('expanded');
    }
}

// Handle window resize to reinitialize accordion on breakpoint changes
function handleResize() {
    if (window.innerWidth <= 767) {
        // Mobile - ensure accordion is active
        handleMobileAccordion();
    } else {
        // Desktop/Tablet - remove accordion classes and restore original structure
        var cards = document.querySelectorAll('.suggested-card');
        cards.forEach(function(card) {
            card.classList.remove('collapsed', 'expanded');
            
            // Restore original structure if it was modified
            var header = card.querySelector('.suggested-card-header');
            var content = card.querySelector('.suggested-card-content');
            
            if (header && content) {
                var ul = content.querySelector('ul');
                if (ul) {
                    card.innerHTML = '';
                    card.appendChild(ul);
                }
            }
        });
    }
}

var shimmerState = {
    isActive: false,
    startTime: null,
    minDisplayDuration: 300, // 300ms minimum display time
    maxDisplayDuration: 10000, // 10s maximum display time
    debounceTimer: null,
    timeoutTimer: null
};

function showShimmer() {
    if (!_vars.initialPromptsShimmer) return;
    
    var suggestedContainer = document.querySelector('.suggested-container');
    var shimmerContainer = document.querySelector('.suggested-shimmer');
    
    if (!suggestedContainer || !shimmerContainer) return;

    // Show shimmer by adding active class
    shimmerContainer.classList.add('active');
    
    // Set ARIA attributes for accessibility
    suggestedContainer.setAttribute('aria-busy', 'true');
    suggestedContainer.setAttribute('aria-live', 'polite');
    suggestedContainer.setAttribute('aria-label', 'Loading prompts');
    
    shimmerState.isActive = true;
    shimmerState.startTime = Date.now();
    
    // Set maximum display timeout
    shimmerState.timeoutTimer = setTimeout(function() {
        hideShimmerOnTimeout('Timeout: Prompts failed to load within 10 seconds');
    }, shimmerState.maxDisplayDuration);
}

function hideShimmer() {
    if (!shimmerState.isActive) return;
    
    var suggestedContainer = document.querySelector('.suggested-container');
    var shimmerContainer = document.querySelector('.suggested-shimmer');
    
    if (!suggestedContainer || !shimmerContainer) return;
    
    var currentTime = Date.now();
    var elapsedTime = currentTime - shimmerState.startTime;
    var minimumTimeRemaining = shimmerState.minDisplayDuration - elapsedTime;
    
    function performHideShimmer() {
        // Hide shimmer by removing active class
        shimmerContainer.classList.remove('active');
        
        // Clear ARIA attributes
        suggestedContainer.removeAttribute('aria-busy');
        suggestedContainer.removeAttribute('aria-label');
        
        shimmerState.isActive = false;
        
        // Clear timers
        if (shimmerState.timeoutTimer) {
            clearTimeout(shimmerState.timeoutTimer);
            shimmerState.timeoutTimer = null;
        }
    }
    
    // Ensure minimum display duration
    if (minimumTimeRemaining > 0) {
        setTimeout(performHideShimmer, minimumTimeRemaining);
    } else {
        performHideShimmer();
    }
}

function hideShimmerOnTimeout(errorMessage) {
    if (!shimmerState.isActive) return;
    
    var suggestedContainer = document.querySelector('.suggested-container');
    var shimmerContainer = document.querySelector('.suggested-shimmer');
    
    if (!suggestedContainer || !shimmerContainer) return;
    
    // Simply hide shimmer by removing active class
    shimmerContainer.classList.remove('active');
    
    // Clear ARIA attributes
    suggestedContainer.removeAttribute('aria-busy');
    suggestedContainer.removeAttribute('aria-label');
    suggestedContainer.removeAttribute('aria-live');
    
    shimmerState.isActive = false;
    console.log('Shimmer timeout:', errorMessage);
    
    // Clear timers
    if (shimmerState.timeoutTimer) {
        clearTimeout(shimmerState.timeoutTimer);
        shimmerState.timeoutTimer = null;
    }
}

// Debounced version to avoid flicker on quick responses
function debounceHideShimmer() {
    if (shimmerState.debounceTimer) {
        clearTimeout(shimmerState.debounceTimer);
    }
    
    shimmerState.debounceTimer = setTimeout(function() {
        hideShimmer();
    }, 150); // 150ms debounce
}

function init() {
    if (!_vars.token) {
        return generateToken().then(function (response) {
            if (!response) {
                return;
            }
            return init();
        }).catch(function (error) {
            console.log("Token generation failed");
        });;
    }
    
    // Show shimmer before starting fetch
    showShimmer();
    
    difyApi.getInitialPrompts().then(function (response) {
        return response.json();
    }).then(function (data) {
        // Hide shimmer before rendering content
        debounceHideShimmer();
        
        var suggestedContainer = document.querySelector('.suggested-container');
        if (data && data.categories && data.categories.length > 0) {
            var cardHtml = '';
            var mobilePromptsHtml = '';
            data.categories.forEach(function (obj, index) {
                var pHtml = '';
                
                if(obj.prompts && obj.prompts.length > 0) {
                    obj.prompts.forEach(function (obj, ind) {
                    pHtml += `<li><div><a href='javascript:void(0)' data-prompt-id="${obj.promptId}" onclick="wmdPageLink('ai-search_initial-cat-` + (index+1) + `-`+ (ind+1) +`', this);">` + obj.prompt + `</a></div><div class='icon'><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.39645 13.1036C5.20118 12.9083 5.20118 12.5917 5.39645 12.3964L9.54289 8.25L5.39645 4.10355C5.20118 3.90829 5.20118 3.59171 5.39645 3.39645C5.59171 3.20118 5.90829 3.20118 6.10355 3.39645L10.25 7.54289C10.6405 7.93342 10.6405 8.56658 10.25 8.95711L6.10355 13.1036C5.90829 13.2988 5.59171 13.2988 5.39645 13.1036Z" fill="#161B1D"/>
                                </svg>
                                </div></li>`;
                    });
                } else {
                    pHtml = 'Examples coming soon - try asking a question in the chat!';
                }
                mobilePromptsHtml += `<div><img src='${obj.icons.light.svg}'>${obj.name}</div>`;
                cardHtml += `<div class="suggested-card" id="suggested-card-${index}">
                            <ul>
                                <li class="heading"><img src='${obj.icons.light.svg}'>${obj.name}</li>${pHtml}</ul>
                        </div>`;
            });
            var titleHtml = `<div class="suggested-title">DISCOVER WHAT YOU CAN ASK MEDSCAPE AI</div>`
            suggestedContainer.innerHTML = '';
            suggestedContainer.insertAdjacentHTML('beforeend', titleHtml)
            suggestedContainer.insertAdjacentHTML('beforeend', cardHtml);
            
            // Clear final ARIA attributes after content is rendered
            setTimeout(function() {
                suggestedContainer.removeAttribute('aria-live');
            }, 100);
            
            handleSuggestedEvents();
            
            // Add resize event listener to handle breakpoint changes
            window.addEventListener('resize', handleResize);
        }
    }).catch(function (error) {
        console.log('Initial prompts fetch error:', error);
        hideShimmerOnTimeout('Failed to load prompts. Please check your connection and try again.');
    });
}

module.exports = {
    init: init
}
